import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import MainLayout from 'src/components/MainLayout';

import { permissions, scssVariables as variables, withRouter, isAdminPage } from 'src/helpers';

import model from 'src/pages/admin/main/model';

import Doctors from 'src/pages/admin/main/Doctors';
import Treatments from 'src/pages/admin/main/Treatments';
import MoneyStatistics from 'src/pages/admin/main/MoneyStatistics';
import Patients from 'src/pages/admin/main/Patients';
import Clinics from 'src/pages/admin/main/Clinics';
import Managers from 'src/pages/admin/main/Managers';
import Messages from 'src/pages/admin/main/Messages';
import TreatmentDetail from 'src/pages/admin/main/TreatmentDetail';
import Doctor from 'src/pages/main/Doctor';
import PatientDetail from 'src/pages/main/Patients/Detail';
import AddPatient from 'src/pages/admin/main/Patients/Edit';
import DoctorStats from 'src/pages/main/DoctorStats';
import AllStats from 'src/pages/admin/main/AllStats';
import AiSettings from 'src/pages/admin/main/AiSettings';
import MobileSettings from 'src/pages/admin/main/MobileSettings';
import settings_pages from 'src/pages/admin/main/Settings';
import { BASE_ICONS, GENERAL_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import VisitCardOrder from './VisitCardOrder';
import Notification from './Notification';
import Appointment from './Appointments';
import AppointmentDetail from './Appointments/Detail';
import AppointmentBook from './Appointments/Book';
import EditAppointment from './Appointments/Edit';
import Tickets from './Tickets';
import Invoices from './Invoices';

const style = {};

style.backgroundColor = variables['colors-mc-white'];

const { PAGES } = permissions;

class Main extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.foxsocket().connect();
    model.on('calling', this.onCalling);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.foxsocket().disconnect();
    model.cancel('calling', this.onCalling);
  }

  onCalling = (partnerId) => {
    if (partnerId > 0) this.navigate(PAGES.ADMIN_MESSAGES_USER_PAGE.match(partnerId));
  };

  componentDidUpdate(prevProps) {
    if (prevProps.router?.location.pathname !== this.props.router?.location.pathname) {
      model.emit('hide_back');
    }
  }

  render() {
    const user = model.getUser();
    return (
      <MainLayout
        currency={model.getCurrency()}
        handleChangeCurrency={model.handleChangeCurrency}
        isAdminPage={isAdminPage()}
        drawMenu={permissions.ACTIVE_PAGE_LIST.filter((p) => p.isDrawMenu)}
        dropdownMenu={permissions.ACTIVE_PAGE_LIST.filter(
          (p) => p.path.includes('settings') && !!p.title
        )}
        user={user}
        showBack={model.state.showBack}
        funcBack={model.state.funcBack}
        logout={() => model.emit('logout')}
      >
        {this.props.children}
      </MainLayout>
    );
  }
}

const MainContainer = withRouter(Main);

const pages = {
  ADMIN_MANAGERS_PAGE: {
    name: 'admin_managers_page',
    path: '/admin/managers',
    isDrawMenu: true,
    title: 'Managers',
    icon: GENERAL_ICONS.MANAGER,
    element: (
      <MainContainer>
        <Managers />
      </MainContainer>
    )
  },
  ADMIN_DOCTORS_PAGE: {
    name: 'admin_doctors_page',
    path: '/admin/doctors',
    icon: 'discovery-icon',
    title: 'Doctors',
    isDrawMenu: true,
    element: (
      <MainContainer>
        <Doctors />
      </MainContainer>
    )
  },
  ADMIN_DOCTORS_DETAIL_PAGE: {
    name: 'admin_doctors_detail',
    path: '/admin/doctors/:username',
    match: (username) => `/admin/doctors/${username}`,
    element: (
      <MainContainer>
        <Doctor />
      </MainContainer>
    )
  },
  ADMIN_PATIENTS_PAGE: {
    name: 'admin_patients_page',
    path: '/admin/clients',
    icon: 'menu-patient-icon',
    title: 'Clients',
    isDrawMenu: true,
    element: (
      <MainContainer>
        <Patients />
      </MainContainer>
    )
  },
  ADMIN_PATIENTS_EDIT_PAGE: {
    name: 'admin_patient_edit_page',
    path: '/admin/clients/:id/edit',
    match: (id) => `/admin/clients/${id}/edit`,
    element: (
      <MainContainer>
        <AddPatient />
      </MainContainer>
    )
  },
  ADMIN_CLINICS_PAGE: {
    name: 'admin_clinics_page',
    path: '/admin/clinics',
    icon: 'discovery-icon',
    title: 'Clinics',
    isDrawMenu: true,
    checkActive: ({ logged, auth }) => logged && auth.isAdmin,
    element: (
      <MainContainer>
        <Clinics />
      </MainContainer>
    )
  },
  ADMIN_PATIENTS_DETAIL_TREATMENT_DETAIL_PAGE: {
    name: 'admin_patient_detail_treatment_detail_page',
    path: '/admin/clients/:id/treatments/:treatmentId',
    match: (id, treatmentId) => `/admin/clients/${id}/treatments/${treatmentId}`,
    element: (
      <MainContainer>
        <TreatmentDetail />
      </MainContainer>
    )
  },
  ADMIN_PATIENTS_DETAIL_PAGE: {
    name: 'admin_patients_detail',
    path: '/admin/clients/:id/:tab',
    match: (id, tab = 'appointments') => `/admin/clients/${id}/${tab}`,
    element: (
      <MainContainer>
        <PatientDetail />
      </MainContainer>
    )
  },
  ADMIN_APPOINTMENTS_DETAIL_PAGE: {
    path: '/admin/appointments/:id',
    match: (id) => `/admin/appointments/${id}`,
    checkActive: ({ auth }) => !!auth,
    element: (
      <MainContainer>
        <AppointmentDetail />
      </MainContainer>
    )
  },
  ADMIN_APPOINTMENTS_EDIT_PAGE: {
    path: '/admin/appointments/:id/edit',
    match: (id) => `/admin/appointments/${id}/edit`,
    checkActive: (params) =>
      !params.appointment || permissions.ACTIONS.APPOINTMENTS_EDIT_BUTTON.checkActive(params),
    element: (
      <MainContainer>
        <EditAppointment />
      </MainContainer>
    )
  },

  ADMIN_APPOINTMENTS_CREATE_PAGE: {
    path: '/admin/appointments/book',
    checkActive: ({ auth }) => !!auth,
    element: (
      <MainContainer>
        <AppointmentBook />
      </MainContainer>
    )
  },
  ADMIN_APPOINTMENTS_REBOOK_PAGE: {
    path: '/admin/appointments/:rebookId/rebook',
    match: (rebookId) => `/admin/appointments/${rebookId}/rebook`,
    checkActive: (params) =>
      !params.appointment || permissions.ACTIONS.APPOINTMENTS_REBOOK_BUTTON.checkActive(params),
    element: (
      <MainContainer>
        <AppointmentBook />
      </MainContainer>
    )
  },
  ADMIN_APPOINTMENTS_RESCHEDULE_PAGE: {
    path: '/admin/appointments/:rescheduleId/reschedule',
    match: (rescheduleId) => `/admin/appointments/${rescheduleId}/reschedule`,
    checkActive: (params) =>
      !params.appointment || permissions.ACTIONS.APPOINTMENTS_RESCHEDULE_BUTTON.checkActive(params),
    element: (
      <MainContainer>
        <AppointmentBook />
      </MainContainer>
    )
  },
  ADMIN_APPOINTMENT_PAGE: {
    path: '/admin/appointments',
    isDrawMenu: true,
    icon: 'appointment-icon',
    title: LANG_CONST.titles.appointments,
    element: (
      <MainContainer>
        <Appointment />
      </MainContainer>
    )
  },
  ADMIN_TREATMENTS_PAGE: {
    name: 'admin_treatments_page',
    path: '/admin/treatments',
    icon: 'treatment-icon',
    title: 'Treatments',
    isDrawMenu: true,
    element: (
      <MainContainer>
        <Treatments />
      </MainContainer>
    )
  },
  ADMIN_TREATMENTS_DETAIL_PAGE: {
    name: 'admin_treatments_detail_page',
    path: '/admin/treatments/:treatmentId',
    match: (treatmentId) => `/admin/treatments/${treatmentId}`,
    element: (
      <MainContainer>
        <TreatmentDetail />
      </MainContainer>
    )
  },
  ADMIN_MONEY_PAGE: {
    name: 'admin_money_statistics_page',
    path: '/admin/money-statistics',
    isDrawMenu: true,
    icon: 'chart-icon',
    title: 'Money Statistics',
    element: (
      <MainContainer>
        <MoneyStatistics />
      </MainContainer>
    )
  },
  ADMIN_TOTALSTATS_PAGE: {
    name: 'admin_totalstats_page',
    path: '/admin/totalstats',
    isDrawMenu: true,
    icon: 'manager-icon',
    title: 'Total Stats',
    element: (
      <MainContainer>
        <DoctorStats />
      </MainContainer>
    )
  },
  ADMIN_ALLSTATS_PAGE: {
    name: 'admin_allstats_page',
    path: '/admin/allstats',
    isDrawMenu: true,
    icon: 'chart-icon',
    title: 'All Stats',
    element: (
      <MainContainer>
        <AllStats />
      </MainContainer>
    )
  },
  ADMIN_MESSAGES_PAGE: {
    name: 'admin_messages_page',
    path: '/admin/messages',
    isDrawMenu: true,
    icon: 'message-icon',
    title: 'Messages',
    element: (
      <MainContainer>
        <Messages />
      </MainContainer>
    )
  },
  ADMIN_MESSAGES_USER_PAGE: {
    name: 'admin_messages_user_page',
    path: '/admin/messages/:id',
    match: (id) => `/admin/messages/${id}`,
    element: (
      <MainContainer>
        <Messages />
      </MainContainer>
    )
  },
  ADMIN_AI_PAGE: {
    name: 'admin_ai_page',
    path: '/admin/ai',
    isDrawMenu: true,
    icon: 'ai-icon',
    title: 'AI Settings',
    element: (
      <MainContainer>
        <AiSettings />
      </MainContainer>
    )
  },
  ADMIN_MOBILE_PAGE: {
    name: 'admin_mobile_page',
    path: '/admin/mobile',
    isDrawMenu: true,
    icon: 'menu-patient-icon',
    title: 'Mobile Settings',
    element: (
      <MainContainer>
        <MobileSettings />
      </MainContainer>
    )
  },
  ADMIN_VISIT_CARD: {
    path: '/admin/print-request',
    isDrawMenu: true,
    icon: BASE_ICONS.PRINTER,
    title: LANG_CONST.titles.printer_request,
    element: (
      <MainContainer>
        <VisitCardOrder />
      </MainContainer>
    )
  },
  ADMIN_NOTIFICATION_PAGE: {
    path: '/admin/notifications',
    isDrawMenu: true,
    icon: BASE_ICONS.NOTIFICATION,
    title: LANG_CONST.titles.notifications,
    element: (
      <MainContainer>
        <Notification />
      </MainContainer>
    )
  },
  ADMIN_TICKETS_PAGE: {
    path: '/admin/tickets',
    isDrawMenu: true,
    icon: BASE_ICONS.MESSAGE_CHECK,
    title: LANG_CONST.chat_tickets,
    element: (
      <MainContainer>
        <Tickets />
      </MainContainer>
    )
  },
  ADMIN_INVOICES_PAGE: {
    name: 'ADMIN_INVOICES_PAGE',
    path: '/admin/invoices',
    isDrawMenu: true,
    icon: 'invoice-icon',
    title: 'Invoices',
    element: (
      <MainContainer>
        <Invoices />
      </MainContainer>
    )
  }
};
for (let k in settings_pages) {
  pages[k] = {
    ...settings_pages[k],
    element: <MainContainer>{settings_pages[k].element}</MainContainer>
  };
}

export default pages;
